export default __webpack_public_path__ + "static/media/Gotham-Book-a513.f15af498.otf";